<mg-overlay-primary
  size="auto"
  [isLoading]="(formState$ | async) === 'loading'"
  [overlayTitle]="MESSAGES.RECORD_EDIT_LABEL">
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <ng-template #overlayFooter>
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </ng-template>
</mg-overlay-primary>

<ng-template #content>
  <main
    class="modal-form"
    #crudForm>
    <!-- Loading -->
    <div
      *ngIf="(formState$ | async) === 'loading'"
      class="loading-container">
      <mg-spinner
        [diameter]="40"
        [thickness]="3">
      </mg-spinner>
    </div>

    <!-- Form -->
    <form
      *ngIf="(formState$ | async) !== 'loading'"
      id="hp-reports-edit-form"
      [formGroup]="form"
      (ngSubmit)="submit()">
      <div
        fxLayout="column"
        fxLayoutAlign="start stretch"
        fxLayoutGap="24px">
        <fieldset *ngIf="(formState$ | async) === 'invalid'">
          <mg-system-alert
            type="error"
            [message]="MESSAGES.RECORD_EDIT_FORM_ERROR">
          </mg-system-alert>
        </fieldset>
        <fieldset
          fxLayout="column"
          fxLayoutGap="12px">
          <mg-form-select
            appendTo="body"
            [control]="form.get(FORM_FIELDS.TYPE)"
            [closeOnSelect]="true"
            [multiple]="false"
            [searchable]="true"
            [hideSelected]="false"
            [options]="behaviorTypesOptions$ | async"
            [placeholder]="MESSAGES.RECORD_EDIT_BEHAVIOR"
            [returnMode]="'full'"
            (selectionChanged)="updateTypeName($any($event))">
          </mg-form-select>
          <mg-form-text-input
            [control]="form.get(FORM_FIELDS.NOTE)"
            [placeholder]="MESSAGES.RECORD_EDIT_NOTE"></mg-form-text-input>
          <div
            class="date-time-row"
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayoutGap="16px">
            <mg-form-date
              class="half-width"
              [control]="form.get(FORM_FIELDS.DATE)"
              [label]="MESSAGES.RECORD_EDIT_DATE">
            </mg-form-date>
            <mg-form-text-input
              class="half-width"
              inputType="time"
              [step]="60"
              [control]="form.get(FORM_FIELDS.TIME)"
              [label]="MESSAGES.RECORD_EDIT_TIME">
            </mg-form-text-input>
          </div>
        </fieldset>
      </div>
    </form>
  </main>
</ng-template>

<ng-template #footerTemplate>
  <footer
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <div>
      <mg-btn
        variant="text"
        (pressed)="cancel()">
        {{ cancelLabel }}
      </mg-btn>
    </div>
    <div>
      <mg-btn
        attrType="submit"
        attrFormId="hp-record"
        variant="filled"
        [disabled]="!canSubmit"
        (pressed)="submit()">
        {{ submitLabel }}
      </mg-btn>
    </div>
  </footer>
</ng-template>
